import React from 'react';
import { drop } from 'lodash';
import ArticleListBoxEm from './ArticleListBoxEm.jsx';
import FeaturedItem from './FeaturedItem.jsx';
import RowWithTwo from './RowWithTwo.jsx';

const TripleNewsBoxEm = ({articles, country, em_banner}) => (
    <ArticleListBoxEm articles={drop(articles, 50)}>
     	<FeaturedItem contentContainer={articles[0]} country={country} /><br/><br/>
        <RowWithTwo articles={[articles[1], articles[2]]} className="featured-news" /><br/><br/>
        <FeaturedItem contentContainer={articles[3]} country={country} /><br/><br/>
        <RowWithTwo articles={[articles[4], articles[5]]} className="featured-news"/><br/><br/>
        <FeaturedItem contentContainer={articles[6]} country={country} /><br/><br/>
        <RowWithTwo articles={[articles[7], articles[8]]} className="featured-news"/><br/><br/>
          <div>
            <img className="em-banner" src={em_banner} alt="Em banner" />
         </div>
        <FeaturedItem contentContainer={articles[9]} country={country} /><br/><br/>
        <RowWithTwo articles={[articles[10], articles[11]]} className="featured-news" /><br/><br/>
        <FeaturedItem contentContainer={articles[12]} country={country} /><br/><br/>
        <RowWithTwo articles={[articles[13], articles[14]]} className="featured-news"/><br/><br/>
        <FeaturedItem contentContainer={articles[15]} country={country} /><br/><br/>
        <RowWithTwo articles={[articles[16], articles[17]]} className="featured-news"/><br/><br/>
        <FeaturedItem contentContainer={articles[18]} country={country} /><br/><br/>
        <RowWithTwo articles={[articles[19], articles[20]]} className="featured-news" /><br/><br/>
        <FeaturedItem contentContainer={articles[21]} country={country} /><br/><br/>
        <RowWithTwo articles={[articles[22], articles[23]]} className="featured-news"/><br/><br/>
        <FeaturedItem contentContainer={articles[24]} country={country} /><br/><br/>
        <RowWithTwo articles={[articles[25], articles[26]]} className="featured-news"/><br/><br/>
        <FeaturedItem contentContainer={articles[27]} country={country} /><br/><br/>
        <RowWithTwo articles={[articles[28], articles[29]]} className="featured-news" /><br/><br/>
        <FeaturedItem contentContainer={articles[30]} country={country} /><br/><br/>
        <RowWithTwo articles={[articles[31], articles[32]]} className="featured-news"/><br/><br/>
        <FeaturedItem contentContainer={articles[33]} country={country} /><br/><br/>
        <RowWithTwo articles={[articles[34], articles[35]]} className="featured-news"/>
        <FeaturedItem contentContainer={articles[36]} country={country} /><br/><br/>
        <RowWithTwo articles={[articles[37], articles[38]]} className="featured-news"/>
        <FeaturedItem contentContainer={articles[39]} country={country} /><br/><br/>
        <RowWithTwo articles={[articles[40], articles[41]]} className="featured-news"/>
        <FeaturedItem contentContainer={articles[42]} country={country} /><br/><br/>
        <RowWithTwo articles={[articles[43], articles[44]]} className="featured-news"/>
        <FeaturedItem contentContainer={articles[45]} country={country} /><br/><br/>
        <RowWithTwo articles={[articles[46], articles[47]]} className="featured-news"/>
        <FeaturedItem contentContainer={articles[48]} country={country} /><br/><br/>
        <RowWithTwo articles={[articles[49], articles[50]]} className="featured-news"/>
    </ArticleListBoxEm>
);

export default TripleNewsBoxEm;



// WEBPACK FOOTER //
// ./src/component/NewsFeed/TripleNewsBoxEm.jsx